import React from 'react'
import injectStyles from 'react-jss'
import { GridItem } from '../../../Page/StatsPageWrapper'
import { styles } from './style'

const formatDateToLocale = date => new Date(date).toLocaleString()

const ClientReferral = ({ clientReferralProgram, classes }) => {
  const listData = [
    {
      description: 'NPS email was sent at:',
      value: clientReferralProgram.npsEmailDate
        ? formatDateToLocale(clientReferralProgram.npsEmailDate)
        : '-',
    },
    {
      description: 'Referral email was set at:',
      value: clientReferralProgram.referralEmailDate
        ? formatDateToLocale(clientReferralProgram.referralEmailDate)
        : '-',
    },
    {
      description: 'Score:',
      value: clientReferralProgram.score ? clientReferralProgram.score : '-',
    },
  ]

  return (
    <div>
      <h1>Client Referral</h1>
      <GridItem>
        <ul className={classes.listWrapper}>
          {listData.map(item => (
            <li>
              <span className={classes.description}>{item.description}</span>
              <span className={classes.value}>{item.value}</span>
            </li>
          ))}
        </ul>
      </GridItem>
    </div>
  )
}

export default injectStyles(styles)(ClientReferral)



// WEBPACK FOOTER //
// ./src/Components/Stats/BulletChartsForMetric/ClientReferral/index.js